import { WButtonComponentProps } from '@alice-health/wonderland'
import { Action } from './ErrorTemplate.types'

type CreateActionProps = {
  label: string
  onClick: () => void
  icon?: WButtonComponentProps['icon']
  isMobile?: boolean
  variant?: WButtonComponentProps['variant']
}

const createAction = ({
  label,
  onClick,
  isMobile,
  variant = 'primary',
  icon
}: CreateActionProps): Action => ({
  label,
  onClick,
  variant: variant,
  size: isMobile ? 'medium' : 'large',
  block: !!isMobile,
  icon
})

export { createAction }
